import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DocumentPreviewModalComponent } from '../components/Modals/document-preview-modal/document-preview-modal.component';
import { AttachmentPreviewConfig } from '../../../shared/managers/attachment-preview.manager';
import { FULLSCREEN_PREVIEW_MODAL_CONFIG } from '../../../shared/managers/fullscreen-preview-modal.config';

@Injectable({
  providedIn: 'root'
})
export class DocumentPreviewManager {

  constructor(private modalService: NzModalService) { }

  /**
   * Open attachment preview modal
   */
  openPreview(config: AttachmentPreviewConfig): void {
    const modalRef = this.modalService.create({
      ...FULLSCREEN_PREVIEW_MODAL_CONFIG,
      nzContent: DocumentPreviewModalComponent,
      nzWrapClassName: 'document-preview-modal-wrapper'
    });

    // Set input parameters after modal is created
    const componentInstance = modalRef.getContentComponent();
    componentInstance.fileId = config.fileId;
    componentInstance.fileName = config.fileName;
    componentInstance.applicationId = config.applicationId!;
  }
}
